// Signup attribution. Links from PREP's emails and referral friends carry
// `?ref=<tag>` (e.g. `em-prep-costs-<contactId>` or `mike`). We keep it for the
// browser session so it survives the multi-step form, then send it with the
// intake so each new store can be traced back to the email or friend that
// brought it.
const KEY = "prep_signup_ref";
const VALID = /^[A-Za-z0-9_.:-]{1,100}$/;

export function sanitizeRef(raw: string | null | undefined): string | null {
  const v = (raw ?? "").trim();
  return VALID.test(v) ? v : null;
}

/** Read `?ref=` from the URL (and remember it); fall back to the remembered one. */
export function captureSignupRef(search: string = window.location.search): string | null {
  const fromUrl = sanitizeRef(new URLSearchParams(search).get("ref"));
  try {
    if (fromUrl) sessionStorage.setItem(KEY, fromUrl);
    return fromUrl ?? sanitizeRef(sessionStorage.getItem(KEY));
  } catch {
    return fromUrl;
  }
}

/** The campaign part of an email ref: `em-prep-costs-<contactId>` -> `em-prep-costs`.
 *  Friend/referral refs and anything else return null, so no personal id is ever
 *  sent to an analytics tool. */
export function emailCampaignFromRef(ref: string | null | undefined): string | null {
  const r = sanitizeRef(ref);
  if (!r || !r.startsWith("em-")) return null;
  return r.replace(/-[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i, "") || null;
}

/** The ref remembered for this browser session, without touching the URL. */
export function getSignupRef(): string | null {
  try {
    return sanitizeRef(sessionStorage.getItem(KEY));
  } catch {
    return null;
  }
}
